import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { eLanguages } from '../../../i18n';
import { ELanguage } from '../../../models/enums/language';
import FormService from '../../../services/form/FormService';
import ServiceRequestForm from './serviceResquestForm';
import { EFormType, IForm } from '../../../models/form/form';
import Topbar from '../../../components/topbar/Topbar';
import { ReactComponent as HBscanLogo } from '../../../assets/images/svg/Group 26.svg';
import { Box, styled, Paper, Typography } from '@mui/material';
import IBuilding from '../../../models/building';
import IFloor from '../../../models/floor';
import ILocal from '../../../models/local';
import { IPropertyGroup } from '../../../models/propertyGroup';

const MainContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "row",
  overflowX: "hidden",
  overflowY: "scroll",
  height: "100%",
  width: "100%",
}));
const ContentContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  width: "100%",
}));

const ServiceRequestPage = () => {
  const [propertyGroup, setPropertyGroup] = useState<IPropertyGroup>();
  const [building, setBuilding] = useState<IBuilding>();
  const [floor, setFloor] = useState<IFloor>();
  const [local, setLocal] = useState<ILocal>();
  const [forms, setForms] = useState<IForm[]>([]);
  const [selectedForm, setSelectedForm] = useState<IForm>();
  const [errorMessage, setErrorMessage] = useState<string>("");
  const { i18n } = useTranslation();
  const { t } = useTranslation(['form']);
  const { localIdOrCode } = useParams();

  useEffect(() => {
    getForm();
  }, []);

  const getForm = async () => {
    if (!localIdOrCode) return setErrorMessage('form:error.localInvalid')

    let local = await FormService.GetLocal(Number(localIdOrCode));
    if (!local.id) local = await FormService.GetLocalByServicePlusStickerCode(localIdOrCode);

    if (!local.id) return setErrorMessage('form:error.localInvalid')

    const floor = await FormService.GetFloor(local.floorId);
    const building = await FormService.GetBuilding(floor.buildingId);
    const propertyGroup = await FormService.GetPropertyGroup(building.propertyGroupId);

    const forms = await FormService.GetFormTemplates((building.companyId && Number(building.companyId)) || 0, '');
    if (!forms || !forms.length) return setErrorMessage('form:error.noForms')

    setLocal(local);
    setFloor(floor);
    setBuilding(building);
    setPropertyGroup(propertyGroup);
    setForms(forms);
  }

  useEffect(() => {
    if (!forms.length || !building) return;

    const lang = eLanguages.get(i18n.language) || ELanguage.English;
    const formsInSelectedLang = forms.find((form) => form.lang === lang && form.formType === EFormType.ServiceRequest && form.buildings.some((b) => b.buildingId == building.id && b.isActive));
    if (!formsInSelectedLang) {
      setErrorMessage('form:error.buildingNoForms')
      return;
    }
    setSelectedForm(formsInSelectedLang);
  }, [forms, i18n.language, building]);

  return (
    <MainContainer>
      <ContentContainer>
        <Topbar />
        {selectedForm && local ? <ServiceRequestForm propertyGroup={propertyGroup} building={building} floor={floor} local={local} form={selectedForm} onChange={(form) => setSelectedForm(form)} />
          :
          <Paper sx={{ borderRadius: 4, px: 3, paddingTop: 3, margin: 'auto', marginTop: 4, overflowY: "scroll", minWidth: "60%", maxWidth: "100%" }}>

            <Box marginBottom={3} sx={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
              <Typography variant="h5" color="error">{t(errorMessage)}</Typography>
            </Box>
          </Paper>
        }

        <Box sx={{ display: "flex", justifyContent: "center" }}><HBscanLogo width={'10vh'} style={{ marginBlock: 15 }} /></Box>
      </ContentContainer >
    </MainContainer >
  );
};

export default ServiceRequestPage;
